import React, { useEffect, useState } from 'react';
import logo from '../images/agribegri_1-removebg-preview.png';
import useOtpAuth from '../hooks/useOtpAuth';
import { SESSION_EXPIRED_KEY } from '../api/apiClient';

const readSessionExpiredMessage = () => {
  try {
    return sessionStorage.getItem(SESSION_EXPIRED_KEY) || '';
  } catch {
    return '';
  }
};

const Login = () => {
  // Read without removing so React StrictMode's double render still sees it; clear after mount.
  const [expiredMessage] = useState(readSessionExpiredMessage);
  useEffect(() => {
    try {
      sessionStorage.removeItem(SESSION_EXPIRED_KEY);
    } catch {
      // nothing to clear
    }
  }, []);
  const {
    mobileNumber,
    setMobileNumber,
    error,
    loading,
    handleSendOtp
  } = useOtpAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    await handleSendOtp();
  };

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh', 
      background: 'linear-gradient(135deg, #e6f9ec 0%, #c8f2d8 100%)' 
    }}>
      <div style={{ 
        background: '#fff', 
        padding: '2.5rem 2rem', 
        borderRadius: '16px', 
        boxShadow: '0 4px 24px #0002', 
        minWidth: 320, 
        maxWidth: 380, 
        width: '100%', 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center' 
      }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 20 }}>
          <img 
            src={logo} 
            alt="AgriBegri Logo" 
            style={{ maxWidth: 200, width: '80%', height: 'auto', marginBottom: 10, display: 'block' }} 
          />
          <h2 style={{ marginBottom: 8, color: 'rgb(24, 73, 43)', letterSpacing: 1 }}><span style={{ fontWeight: 500 }}>Welcome To </span><span style={{ fontWeight: 700, fontSize: 28, color: 'green' }}>Darshaka</span></h2>
        </div>
        
        {(error || expiredMessage) && (
          <div style={{ 
            color: '#d32f2f', 
            marginBottom: 12, 
            fontWeight: 500,
            padding: '8px 12px',
            background: '#ffebee',
            borderRadius: 6,
            width: '100%',
            textAlign: 'center'
          }}>
            {error || expiredMessage}
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <div style={{ marginBottom: 18 }}>
            <label style={{ fontWeight: 500, color: '#18492b', fontSize: 15 }}>Mobile Number</label>
            <input 
              type="tel"
              value={mobileNumber}
              onChange={e => setMobileNumber(e.target.value.replace(/\D/g, '').slice(0, 10))}
              placeholder="Enter 10-digit mobile number"
              style={{ 
                width: '100%', 
                padding: '10px 12px', 
                borderRadius: 8, 
                border: '1px solid #b2dfc7', 
                marginTop: 6,
                fontSize: 15,
                background: '#f6fcf8',
                outline: 'none',
                transition: 'border 0.2s',
                boxSizing: 'border-box'
              }}
              disabled={loading}
            />
          </div>

          <button 
            type="submit" 
            style={{ 
              width: '100%', 
              background: 'linear-gradient(90deg, #38b87c 0%, #18492b 100%)', 
              color: '#fff', 
              padding: '12px 0', 
              border: 'none', 
              borderRadius: 8, 
              fontWeight: 600, 
              fontSize: 16,
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'all 0.2s',
              marginTop: 6,
              boxShadow: '0 2px 8px #38b87c22',
              opacity: loading ? 0.7 : 1
            }}
            disabled={loading}
          >
            {loading ? 'Please wait...' : 'Send OTP'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login; 